
import { Eye, TrendingUp, MessageCircle } from "lucide-react";

interface ListingType {
  id: string;
  title: string;
  address: string;
  price: string;
  type: string;
  status: string;
  views: number;
  inquiries: number;
  image: string;
  featured: boolean;
  boosted: boolean;
  hasUnreadMessages?: boolean;
  hasUpdates?: boolean;
}

interface ListingStatsProps {
  property: ListingType;
}

const ListingStats = ({ property }: ListingStatsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="flex items-start">
        <div className="bg-green-100 p-2 rounded-full mr-3">
          <Eye className="h-4 w-4 text-green-600" />
        </div>
        <div>
          <span className="text-sm text-muted-foreground">Views</span>
          <div className="text-lg font-medium">{property.views}</div>
          <p className="text-xs text-muted-foreground">
            <TrendingUp className="inline h-3 w-3 text-green-500 mr-1" />
            <span className="text-green-500">+2</span> this week
          </p>
        </div>
      </div>
      <div className="flex items-start">
        <div className="bg-purple-100 p-2 rounded-full mr-3">
          <MessageCircle className="h-4 w-4 text-purple-600" />
        </div>
        <div>
          <span className="text-sm text-muted-foreground">Inquiries</span>
          <div className="text-lg font-medium">{property.inquiries}</div>
          <p className="text-xs text-muted-foreground">
            <TrendingUp className="inline h-3 w-3 text-green-500 mr-1" />
            <span className="text-green-500">+1</span> this week
          </p>
        </div>
      </div>
    </div>
  );
};

export default ListingStats;
